import { withOptionsEndpoint } from "@dgs/core";
import { TargetGroupOptionResource } from "../types/targetGroup";

const baseKey = ["target-groups"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const targetGroupService = {
	...withOptionsEndpoint<TargetGroupOptionResource>(baseKey),
	quickFilterKey,
};
